import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { DownloadProgressProps } from './types';
import styles from './DownloadProgress.module.css';

/**
 * ダウンロード進捗を表示するフローティングコンポーネント
 */
const DownloadProgress: React.FC<DownloadProgressProps> = ({
  id,
  fileName,
  progress,
  loaded,
  total,
  open,
  onClose,
  index = 0
}) => {
  // ファイルサイズを読みやすい形式に変換
  const formatBytes = (bytes: number): string => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${(bytes / Math.pow(k, i)).toFixed(1)} ${sizes[i]}`;
  };

  // 進捗率を計算（0-100%）
  const progressPercentage = Math.min(100, Math.max(0, progress));

  // ファイル名が長い場合は省略
  const displayFileName = fileName.length > 30 
    ? `${fileName.substring(0, 30)}...` 
    : fileName;

  const stateClass = open ? styles.downloadProgress__open : styles.downloadProgress__close;
  // インデックスに基づいてスタッキング用のクラスを追加
  let stackingClass = '';
  if (index === 1) stackingClass = styles.downloadProgress__stacking_1;
  else if (index === 2) stackingClass = styles.downloadProgress__stacking_2;
  else if (index === 3) stackingClass = styles.downloadProgress__stacking_3;
  else if (index === 4) stackingClass = styles.downloadProgress__stacking_4;

  return (
    <div 
      className={`${styles.downloadProgress} ${stateClass} ${stackingClass}`}
      data-testid={`download-progress-${id}`}
    >
      <div className={styles.downloadProgress__content}>
        <div className={styles.downloadProgress__header}>
          <div className={styles.downloadProgress__fileName} data-testid={`download-progress-filename-${id}`}>
            {displayFileName}
          </div>
          <button 
            className={styles.downloadProgress__close_btn} 
            onClick={onClose}
            data-testid={`download-progress-close-btn-${id}`}
            aria-label="閉じる"
          >
            <FaTimes />
          </button>
        </div>
        
        <div className={styles.downloadProgress__progressContainer}>
          <div className={styles.downloadProgress__progressBar}>
            <div 
              className={styles.downloadProgress__progressFill}
              style={{ width: `${progressPercentage}%` }}
              data-testid={`download-progress-bar-${id}`}
            />
          </div>
          <div className={styles.downloadProgress__progressInfo}>
            <span className={styles.downloadProgress__percentage}>
              {progressPercentage.toFixed(1)}%
            </span>
            <span className={styles.downloadProgress__size}>
              {formatBytes(loaded)} / {formatBytes(total)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadProgress;
